import { Component, OnChanges, inject, input } from "@angular/core";
import { faUps } from "@fortawesome/free-brands-svg-icons"; // 'fa-brands' (Brand version)

import { AppConfig, APP_CONFIG_TOKEN } from "libs/config/app.lib.config";
import {
	DataTransferMethod,
	TreatmentModel,
	TreatmentStatus
} from "libs/treatments/src/lib/models";
import { ProductInfoService } from "libs/product/src/lib/services";
import { UpsPickupInfo } from "libs/tm-common/src/lib/models/ups.model";
import { TreatmentService } from "libs/treatments/src/lib/services/treatment.lib.service";
import { CustomerSession } from "libs/tm-common/src/lib/models/user.model";
import { NgClass, DatePipe } from "@angular/common";
import { FaIconComponent } from "@fortawesome/angular-fontawesome";
import { ShippingInsertPrintComponent } from "../shipping-insert-print/shipping-insert-print.component";
import { TranslatePipe } from "@ngx-translate/core";
import { TreatmentStatusToStringPipe } from "libs/tm-common/src/lib/pipes/treatmentStatusToString.pipe";
import { faBox, faCopy } from "@fortawesome/pro-light-svg-icons";
import { MatButton } from "@angular/material/button";
import { ClipboardModule } from "ngx-clipboard";

@Component({
	selector: "lib-treatment-detail-header",
	templateUrl: "./treatment-detail-header.component.html",
	styleUrls: ["./_treatment-detail-header.component.scss"],
	imports: [
		NgClass,
		MatButton,
		ClipboardModule,
		FaIconComponent,
		ShippingInsertPrintComponent,
		DatePipe,
		TreatmentStatusToStringPipe,
		TranslatePipe
	]
})
export class TreatmentDetailHeaderComponent implements OnChanges {
	private treatmentService = inject(TreatmentService);
	private productInfoService = inject(ProductInfoService);
	config = inject<AppConfig>(APP_CONFIG_TOKEN);

	faUps = faUps;
	faBox = faBox;
	faCopy = faCopy;
	readonly shippingAddress = "SCHEU-DENTAL custom-made GmbH\nWalder Straße 53\n40724 Hilden";

	readonly customerSession = input<CustomerSession>(undefined);
	readonly patient = input(undefined);
	readonly treatment = input<TreatmentModel>(null);
	TreatmentStatus = TreatmentStatus;
	DataTransferMethod = DataTransferMethod;
	pickUpInfo: UpsPickupInfo | null = null;

	ngOnChanges() {
		this.pickUpInfo =
			this.treatment().upsPickupReferences?.length > 0
				? this.treatmentService.checkPickUpInfo(this.treatment().upsPickupReferences.at(-1))
				: null;
	}
	getToothAreaForProduct(isUpperJaw: boolean): string {
		return this.productInfoService.getToothAreaForProduct(this.treatment().product, isUpperJaw);
	}

	getCreatedDate(): Date {
		if (this.treatment().schema_version >= 2) {
			return this.treatment().quotation?.created ?? this.treatment().created;
		} else {
			return this.treatment().orders.at(-1).created;
		}
	}

	getQuotationOrOrderId(): string {
		if (this.treatment().schema_version >= 2) {
			return this.treatment().quotation.docNum ?? "-";
		} else {
			return this.treatment().orders.at(-1).realId;
		}
	}
}
